import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Connector } from '../Connector'
import { AnchorTypes } from '../types'

export interface AnnotationProps {
  /** Visual for the annotation */
  children?: ReactNode
  /** x-Position in percent of the image size */
  left?: number
  /** y-Position in percent of the image size */
  top?: number
  /** alignment of the annotation from the target */
  anchor?: AnchorTypes
  /** distance of the annotation from the target  */
  distance?: number
  /** description of the desired marker  */
  Marker?: ReactNode
  /** draw connector line between target and annotation  */
  connect?: boolean
  /** description of the desired connector  */
  connector?: ConnectorType
}

export const Annotation: FC<AnnotationProps> = ({
  children,
  left = 0,
  top = 0,
  anchor = 'bottom-right',
  distance = 0,
  connect = false,
  Marker,
  connector,
}) => {
  const textAlign =
    anchor === 'top' || anchor === 'bottom'
      ? 'center'
      : anchor.includes('left')
      ? 'right'
      : 'left'

  const moveX =
    anchor === 'top' || anchor === 'bottom'
      ? -50
      : anchor.includes('left')
      ? -100
      : 0

  const moveY = anchor.includes('top')
    ? -100
    : anchor.includes('bottom')
    ? 0
    : -50

  const distanceX =
    (anchor === 'top' || anchor === 'bottom'
      ? 0
      : anchor.includes('left')
      ? -distance
      : distance) * (anchor.includes('-') ? 0.72 : 1)

  const distanceY =
    (anchor === 'left' || anchor === 'right'
      ? 0
      : anchor.includes('top')
      ? -distance
      : distance) * (anchor.includes('-') ? 0.72 : 1)

  return (
    <AnnotationRoot className='anno_root' {...{ left, top, textAlign }}>
      <AnnotationContent {...{ moveX, moveY, distanceX, distanceY }}>
        {children && children}
      </AnnotationContent>
      {connect &&
        connector &&
        connector.style &&
        connector.type &&
        connector.direction && (
          <Connector
            {...{ ...{ moveX, moveY }, ...connector }}
            style={connector.style}
            width={distanceX}
            height={distanceY}
            type={connector.type}
            direction={connector.direction}
          />
        )}
      {Marker && Marker}
    </AnnotationRoot>
  )
}

const AnnotationRoot = styled.div<{
  left: number
  top: number
  textAlign: 'left' | 'right' | 'center'
}>`
  box-sizing: border-box;
  position: absolute;
  left: ${({ left }) => left + '%'};
  top: ${({ top }) => top + '%'};
  text-align: ${({ textAlign }) => textAlign};
`
const AnnotationContent = styled.div<{
  moveX: number
  moveY: number
  distanceX: number
  distanceY: number
}>`
  position: absolute;
  top: 0;
  left: 0;
  transform: ${({ moveX, moveY, distanceX, distanceY }) =>
    `translate(calc(${moveX}% + ${distanceX}px),calc(${moveY}% + ${distanceY}px))`};
`
